module.exports = __webpack_public_path__ + "static/media/list-fill-primary.8f671878.svg";